import { StarIcon } from './StarIcon';

/**
 * author: Google
 * id 53D81A11-D8FF-46F4-A0CB-B7F668BA720D
 * name star
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star.svg
 * tags
 * - Shape 
 */
export const GradeIcon = StarIcon;
export default GradeIcon